module.exports = __webpack_public_path__ + "static/media/10_background.821874f4.png";